import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const ShopStandards = () => {
    const [ref, inView] = useInView({
        threshold: 0.1,
        triggerOnce: true
    });

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
                duration: 0.8
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, scale: 0.9 },
        visible: {
            opacity: 1,
            scale: 1,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        }
    };

    // Shop standards images
    const standardImages = Array.from({ length: 8 }, (_, i) => ({
        id: i + 1,
        src: `/standards/standard_${i + 1}.webp`,
        alt: `Shop Standard ${i + 1}`
    }));

    return (
        <section className="py-8 md:py-12 bg-white">
            <div className="container mx-auto px-4 md:px-8">
                {/* Title */}
                <motion.div
                    ref={ref}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={containerVariants}
                    className="text-center mb-8 md:mb-12"
                >
                    <motion.h2
                        variants={itemVariants}
                        className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-4"
                    >
                        Our <span className="text-secondary">Standards</span>
                    </motion.h2>
                </motion.div>

                {/* Standards Gallery - Single Line, Small Images */}
                <motion.div
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={containerVariants}
                    className="grid grid-cols-4 md:grid-cols-8 gap-2 md:gap-4"
                >
                    {standardImages.map((standard) => (
                        <motion.img
                            key={standard.id}
                            variants={itemVariants}
                            whileHover={{
                                scale: 1.05,
                                transition: { duration: 0.3 }
                            }}
                            src={standard.src}
                            alt={standard.alt}
                            className="w-full h-20 md:h-24 object-contain hover:opacity-90 transition-all duration-300"
                            loading="lazy"
                        />
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default ShopStandards;